export default {
  "menu.AttendanceRecordNewPage": '补签',
}